import { getPartyById } from '../../../../common/src/legacy/services/apiRouterService';
import store from '../../../store/redux/store';

interface Params {
  partyId?: string;
}

export const hasPartyCBE = async ({ partyId }: Params): Promise<boolean> => {
  if (partyId) {
    const [prospect, status] = await getPartyById(partyId);

    if (status < 400 && prospect?.company_registration?.nr) return true;
  }

  return false;
};

export const hasSelectedCompanyCBE = (): boolean => {
  const selectedCompanyCBE =
    store.getState().companyScan.selectedCompany?.company_registration?.nr;
  if (selectedCompanyCBE) {
    return true;
  }
  return false;
};

export const hasCompanyScanCompanyCBE = async (
  params: Params,
): Promise<boolean> => {
  return (await hasPartyCBE(params)) || hasSelectedCompanyCBE();
};
